
import { Injectable } from '@angular/core';
import {
  Resolve,
  RouterStateSnapshot,
  ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of, EMPTY } from 'rxjs';

export abstract class RouteResolverService implements Resolve<string> {
  constructor(public readonly paramName: string) { }
  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Observable<string> | Observable<never> {
    if (!this.paramName) {
      return EMPTY;
    } else {
      return of(route.paramMap.get(this.paramName));
    }
  }
}

@Injectable({
  providedIn: 'root',
})
export class CedantIdResolverService extends RouteResolverService {
  constructor() {
    super('cedantId');
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProgramIdResolverService extends RouteResolverService {
  constructor() {
    super('programId');
  }
}
